import dayjs from 'dayjs';

import type { Dayjs } from 'dayjs';

const isDayjs = (v: unknown): v is Dayjs =>
  Boolean(v) && typeof (v as Dayjs).isValid === 'function';

const isDate = (v: unknown): v is Date => v instanceof Date;

const dateToISO = (v: unknown): string | null => {
  if (v == null || v === '') return null;
  if (typeof v === 'string') return v;
  if (isDayjs(v)) return v.format('YYYY-MM-DD');
  if (isDate(v)) return dayjs(v).format('YYYY-MM-DD');
  return null;
};

const toNumArray = (v: unknown): number[] | null => {
  if (v == null) return null;
  if (!Array.isArray(v)) return null;
  const nums = v.map((x) => Number(x)).filter((n) => Number.isFinite(n));
  return nums.length ? nums : [];
};

const toStrArray = (v: unknown): string[] | null => {
  if (v == null) return null;
  if (Array.isArray(v)) return v.map(String);
  if (typeof v === 'string' && v.trim()) return [v];
  return [];
};

export const typeGuards = {
  isDayjs,
  isDate,
  dateToISO,
  toNumArray,
  toStrArray,
};
